export default "__VITE_ASSET__497339bd__"